module.exports = __webpack_public_path__ + "static/assets/4327772f391bbf3c39779fc406c21c88.svg";